import dynamic from 'next/dynamic';
import { useRef } from 'react';
import { useInView } from 'motion/react';

// Gravity Forms is the single most expensive thing on the site, and until this
// existed it loaded on 100% of pages because the footer newsletter sign-up
// mounts inside every layout. Beyond the ~440KB JS bundle it also triggers
// reCAPTCHA v2, which pulls ~345KB of gstatic script (twice, when two forms are
// on a page), two iframes, a stylesheet and a Roboto webfont — around 550ms of
// script evaluation on a mid-range phone, on pages with no visible form.
//
// So: don't render it until the user is heading towards it. `ssr: false`
// because the form is entirely client-side anyway (next-gravity-forms hydrates
// its own widgets) and there is nothing in it a crawler needs.
const GravityFormBundle = dynamic(() => import('./GravityFormBundle'), {
  ssr: false,
});

export default function LazyGravityForm({
  className,
  // Mount well before the form scrolls into view so it is never seen to pop in.
  rootMargin = '600px',
  // Holds the slot open until the form mounts. Dropped once it has, so the real
  // form's height wins and a wrong guess can't leave a gap.
  minHeight = 160,
  ...props
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: rootMargin });

  return (
    <div
      ref={ref}
      className={className}
      style={inView ? undefined : { minHeight }}
    >
      {inView && <GravityFormBundle {...props} />}
    </div>
  );
}
